export default {
  name: 'validation-input',
  props: {
      //value:[String, Number],
      name: {},
      id: {},
      value: {},
      type: {default: 'text'},
      placeholder: {},
      inputClass: {default: 'input-class'},
      inputErrorClass: {default: 'input-error'},
      errorClass: {default: 'form-field-error'},
      validations: {type: Object},
      modelName: {},
      validator: {},
      options: {type: Object},
      noElement: {type: Boolean, default: false}
    },
  data() {
    return {}
  },
  methods: {

    onInput(event) {
      const value = event.target.value
      this.$emit('input', value)
      if (this.hasError) {
        this.$emit('inputError', event, {name: this.vName, value})
      }
    },
    vCheck() {
      const validator = this.validator || (this.validations && this.validations.validator)
      if (_.isFunction(validator)) {
        return validator(...arguments)
      }
      return null
    }
  },
  computed: {
    hasError() {
      return _.some(this.vItems, (i, rule) => this.vCheck(this.vName, rule))
    },
    vName() {
      return this.validations.name
    },
    vItems() {
      return this.validations.items || {}
    },
  }
}
